import axios from 'axios';

export const setPaymentMethodOnCart = async (cartId, paymentCode, authToken) => {
  const data = JSON.stringify({
    query: `mutation {
      setPaymentMethodOnCart(input: {
          cart_id: "${cartId}"
          payment_method: {
              code: "${paymentCode}"
          }
      }) {
        cart {
          selected_payment_method {
            code
          }
        }
      }
    }`,
    variables: {}
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://mcstaging.candere.com/graphql',
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${authToken}`, 
    },
    withCredentials: true,
    data: data
  };

  try {
    const response = await axios.request(config);
    console.log(JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error('Error setting payment method:', error);
    throw error;
  }
};
